module.exports = __webpack_public_path__ + "static/media/bg_13.144c928c.png";